import textContent from 'utils/DOM/textContent'
import toggleClass from 'utils/DOM/toggleClass'

function renderPreOpBanner(stateAcronym: string, text: string) {
  const applicantStates = ['VA']

  if (applicantStates.find(stateName => stateName === stateAcronym)) {
    textContent('.notice-banner__main', text)
    toggleClass('.notice-banner', 'd-block', true)
  }
}

export default renderPreOpBanner
